module.exports = __webpack_public_path__ + "static/media/second-splash.7a948840.png";